import React, { useState } from "react";
import { Link } from "react-router-dom";

const Template = ({ children }) => {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const [sideBarOpen, setSideBarOpen] = useState(false);

  console.log(sideBarOpen);

  const handleMobileMenuToggle = () => {
    setMobileMenuOpen((prev) => !prev);
  };

  const handleSideBarToggle = () => {
    setSideBarOpen((prev) => !prev);
  };

  return (
    <>
      <header
        className={`${mobileMenuOpen && "active"} site-header header-style-1`}
      >
        <div className="site-header-menu">
          <div className="container-fluid g-0">
            <div className="row g-0">
              <div className="col-md-12">
                <div className="d-flex align-items-center justify-content-between">
                  <div className="d-flex align-items-center justify-content-between header-content">
                    <div className="site-branding pbmit-logo-area">
                      <h1 className="site-title">
                        <Link to="/">
                          <img
                            src="assets/images/daily/logo.png"
                            className="logo-img"
                            style={{ width: "140px", height: "auto" }}
                            alt="Daily Fitness"
                          />
                        </Link>
                      </h1>
                    </div>
                  </div>{" "}
                  <div className="site-navigation">
                    <nav className="main-menu navbar-expand-xl navbar-light">
                      <div className="navbar-header">
                        {/* Toggle Button*/}
                        <button
                          className="navbar-toggler"
                          type="button"
                          onClick={handleMobileMenuToggle}
                        >
                          <i className="pbmit-base-icon-menu-1"></i>
                        </button>
                      </div>
                      <div className="pbmit-mobile-menu-bg"></div>
                      <div
                        className="collapse navbar-collapse clearfix show"
                        id="pbmit-menu"
                      >
                        <div className="pbmit-menu-wrap">
                          <button
                            className="closepanel"
                            onClick={handleMobileMenuToggle}
                          >
                            <svg
                              className="qodef-svg--close qodef-m"
                              // xmlns="http://www.w3.org/2000/svg"
                              width="20.163"
                              height="20.163"
                              viewBox="0 0 26.163 26.163"
                            >
                              <rect
                                width="36"
                                height="1"
                                transform="translate(0.707) rotate(45)"
                              ></rect>
                              <rect
                                width="36"
                                height="1"
                                transform="translate(0 25.456) rotate(-45)"
                              ></rect>
                            </svg>
                          </button>

                          <ul className="navigation clearfix">
                            {/* <li>
                                <Link to="/">Home</Link>
                              </li> */}
                            <li>
                              <Link to="/fitness">Fitness</Link>
                            </li>
                            <li>
                              <Link to="/performance">Performance</Link>
                            </li>
                            <li>
                              <Link to="/clarity-call">Clarity Call</Link>
                            </li>

                            <li>
                              <Link to="/about">About Us</Link>
                            </li>
                             <li>
                              <a href="https://preview.scioondigital.com/gym/admin/fitness-login.php">Login</a>
                            </li>
                            {/* <li>
                                <Link to="/gallery">Gallery</Link>
                              </li>
                              <li>
                                <Link to="/contact">Contact Us</Link>
                              </li> */}
                          </ul>
                        </div>
                      </div>
                    </nav>
                  </div>
                  <div className="pbmit-right-box">
                    <div className="pbmit-button-box">
                      <div className="pbmit-header-button2">
                        <Link to="/fitness/#pricing">
                          <span className="pbmit-header-button2-text">
                            Start 3 days Trial
                          </span>
                        </Link>
                      </div>
                    </div>
                    <div className="pbmit-menuarea">
                      <div className="navbar-header">
                        {/* Toggle Button*/}
                        <button
                          className="navbar-toggler pbmit-nav-menu-toggle"
                          onClick={handleSideBarToggle}
                          type="button"
                        >
                          <svg
                            className="qodef-svg--menu qodef-m"
                            // xmlns="http://www.w3.org/2000/svg"
                            width="36"
                            height="21"
                            viewBox="0 0 36 21"
                          >
                            <path
                              d="M0,0H36V1H0Z"
                              transform="translate(0 20)"
                            ></path>
                            <path
                              d="M0,0H36V1H0Z"
                              transform="translate(0 10)"
                            ></path>
                            <path d="M0,0H36V1H0Z"></path>
                          </svg>
                        </button>
                      </div>
                      <div
                        className={`floting-bar-wrap ${
                          sideBarOpen && "active"
                        }`}
                      >
                        <div className="floting-bar-widget-area">
                          <aside className="widget widget_media_image">
                            <img
                              src="assets/images/daily/logo.png"
                              className="img-fluid"
                              style={{
                                width: "120px",
                                height: "auto",
                                filter: "invert(1) brightness(2)",
                              }}
                              alt=""
                            />
                          </aside>
                          <aside className="widget widget_text">
                            <div className="textwidget">
                              <p>
                                Coach Elite is a body first performance system
                                for clarity, consistency, and better decisions
                                without burnout. We build physical capacity to
                                regulate energy, focus, and resilience.
                                Structured performance coaching then shapes
                                daily routines and execution under pressure.
                                From fitness to career growth, Coach Elite
                                supports long term performance and leadership.
                              </p>
                            </div>
                          </aside>
                          <aside className="widget_text widget widget_custom_html">
                            <div className="textwidget custom-html-widget">
                              <div className="pbmit-contact-box">
                                <div className="pbmit-contact-list pbmit-phone">
                                  <h4>CALL &amp; MAIL</h4>
                                  <span>
                                    {" "}
                                    <a
                                      href="tel:+91 93813 31969"
                                      style={{ color: "inherit" }}
                                    >
                                      +91 93813 31969
                                    </a>
                                  </span>
                                  <span>
                                    <a
                                      href="mailto:coaching@dailyfitzone.com"
                                      style={{ color: "inherit" }}
                                    >
                                      coaching@dailyfitzone.com
                                    </a>
                                  </span>
                                </div>
                                <div className="pbmit-contact-list pbmit-time">
                                  <h4>OPENING HOURS</h4>
                                  <span>Monday to Saturday</span>
                                  <span>6:30 am — 11:00 pm IST</span>
                                  <span>Clarity Call On Appoinment Based</span>
                                </div>
                              </div>
                            </div>
                          </aside>
                        </div>
                        <div className="floting-bar-social-wrap">
                          <div className="floting-bar-social-title">
                            <h4>FOLLOW US ON</h4>
                            <ul className="pbmit-social-links">
                              <li className="pbmit-social-li pbmit-social-facebook">
                                <a
                                  href="https://www.facebook.com/share/1DexYAeQUr/?mibextid=wwXIfr"
                                  target="_blank"
                                >
                                  <span>
                                    <i className="pbmit-base-icon-facebook-f"></i>
                                  </span>
                                </a>
                              </li>
                              <li className="pbmit-social-li pbmit-social-instagram">
                                <a
                                  href="https://www.instagram.com/coach_elite_?igsh=eDI4bnk1dXZ4bzE5&utm_source=qr"
                                  target="_blank"
                                >
                                  <span>
                                    <i className="pbmit-base-icon-instagram"></i>
                                  </span>
                                </a>
                              </li>
                              <li className="pbmit-social-li pbmit-social-linkedin">
                                <a
                                  href="https://www.linkedin.com/company/coachelite85"
                                  target="_blank"
                                >
                                  <span>
                                    <i className="pbmit-base-icon-linkedin-in"></i>
                                  </span>
                                </a>
                              </li>
                            </ul>
                          </div>
                        </div>
                        <button
                          className="closepanel"
                          onClick={handleSideBarToggle}
                        >
                          <svg
                            className="qodef-svg--close qodef-m"
                            width="26.163"
                            height="26.163"
                            viewBox="0 0 26.163 26.163"
                          >
                            <rect
                              width="36"
                              height="1"
                              transform="translate(0.707) rotate(45)"
                            ></rect>
                            <rect
                              width="36"
                              height="1"
                              transform="translate(0 25.456) rotate(-45)"
                            ></rect>
                          </svg>
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </header>
      <div className="page-content pbmit-bg-color-blackish">{children}</div>
      {/* footer */}
      <footer className="footer site-footer">
        <div className="container">
          <div className="footer-wrap pbmit-footer-big-area">
            <div className="row">
              <div className="col-md-12 col-xl-5">
                <div className="pbmit-footer-logo">
                  <img
                    src="assets/images/daily/logo.png"
                    className="img-fluid"
                    style={{ width: "160px", height: "auto" }}
                    alt="Daily Fitness"
                  />
                </div>
              </div>
              <div className="col-xl-7 col-md-12 pbmit-footer-right">
                <h2>
                  <i style={{ color: "#05AAE3" }}>
                    A body first performance system
                  </i>
                  <br />
                  Build physical capacity, daily discipline, and decision
                  clarity without burnout.
                </h2>
              </div>
            </div>
          </div>
          <div className="pbmit-footer-widget-area">
            <div className="row align-items-center">
              <div className="col-md-6 col-lg-3 widget-col-1">
                <div className="widget">
                  <img
                    src="assets/images/demo1/LOCATION.png"
                    className="img-fluid"
                    alt="Daily Fitness"
                  />
                  <div className="textwidget">
                    <div className="pbmit-contact-widget-line pbmit-contact-widget-address">
                      Coach Elite Flat no 221,Fortune Falcon Green Home, Block 3
                      Road No 14, Alkapuri Township Puppalguda Hyderabad,
                      Telegana-500089 India India
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-md-6 col-lg-3 widget-col-2">
                <div className="widget">
                  <h2 className="widget-title">Explore</h2>
                  <ul className="pbmit-timelist-list">
                    <li>
                      <span className="pbmit-timelist-li-title">
                        <Link to="/about">About Us</Link>
                      </span>
                    </li>
                    <li>
                      <span className="pbmit-timelist-li-title">
                        <Link to="/fitness">Fitness Foundation</Link>
                      </span>
                    </li>
                    <li>
                      <span className="pbmit-timelist-li-title">
                        <Link to="/performance">Performance Coaching</Link>
                      </span>
                    </li>
                  </ul>
                </div>
              </div>
              <div className="col-md-6 col-lg-3 widget-col-2">
                <div className="widget">
                  <h2 className="widget-title">Working Hours</h2>
                  <div className="textwidget pbmit-timelist-wrapper">
                    <ul className="pbmit-timelist-list">
                      <li>
                        <span className="pbmit-timelist-li-title">
                          Mon – Fri : 9.00AM – 6.00PM
                        </span>
                      </li>
                      <li>
                        <span className="pbmit-timelist-li-title">
                          Sat - Sun: Closed
                        </span>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
              <div className="col-md-6 col-lg-3 widget-col-2">
                <div className="widget">
                  <h2 className="widget-title">Contact</h2>
                  <ul className="pbmit-timelist-list">
                    <li>
                      <span className="pbmit-timelist-li-title">
                        <a href="tel:+91 93813 31969">+91 93813 31969</a>
                      </span>
                    </li>
                    <li>
                      <span className="pbmit-timelist-li-title">
                        <a href="mailto:coaching@dailyfitzone.com">
                          coaching@dailyfitzone.com
                        </a>
                      </span>
                    </li>
                    <li>
                      <span className="pbmit-timelist-li-title">
                        <a>
                          Legal Entity: CoachElite
                          <br />
                          Brand Name: DailyFitZone
                        </a>
                      </span>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="pbmit-footer-section">
          <div className="container">
            <div className="pbmit-footer-text-inner">
              <div className="row">
                <div className="col-md-6">
                  <div className="pbmit-footer-copyright-text-area">
                   © 2026 DailyFitZone. Owned and operated by CoachElite.
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="pbmit-footer-menu-area">
                    <div className="menu-copyright-menu-container">
                      <ul className="pbmit-footer-menu">
                        <li className="menu-item">
                          <Link to="/privacy-policy">Privacy & Policy</Link>
                        </li>
                        <li className="menu-item">
                          <Link to="/terms-and-conditions">
                            Terms of Conditions
                          </Link>
                        </li>
                        <li className="menu-item">
                          <Link to="/refund-policy">
                            Return and Refund Policy
                          </Link>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </footer>
      {/* footer End */}
    </>
  );
};

export default Template;
